import { CommonModule }    from '@angular/common';
import { NgModule }        from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AreaChartComponent }      from './area-chart/area-chart.component';
import { BarChartComponent }       from './bar-chart/bar-chart.component';
import { ChartCardComponent }      from './chart-card/chart-card.component';
import { ChartInfoPanelComponent } from './chart-info-panel/chart-info-panel.component';
import { ChartLegendComponent }    from './chart-legend/chart-legend.component';
import { ComponentsModule }        from '../components.module';
import { DonutChartComponent }     from './donut-chart/donut-chart.component';
import { HbarChartComponent }      from './hbar-chart/hbar-chart.component';
import { SortHeaderComponent }     from './sort-header/sort-header.component';

// Imported by the feature modules that draw charts, so only their bundles carry the kit
@NgModule({
  declarations: [
    AreaChartComponent,
    BarChartComponent,
    ChartCardComponent,
    ChartInfoPanelComponent,
    ChartLegendComponent,
    DonutChartComponent,
    HbarChartComponent,
    SortHeaderComponent
  ],
  exports: [
    AreaChartComponent,
    BarChartComponent,
    ChartCardComponent,
    ChartInfoPanelComponent,
    ChartLegendComponent,
    DonutChartComponent,
    HbarChartComponent,
    SortHeaderComponent
  ],
  imports: [
    // Angular
    CommonModule,

    // Third Party
    TranslateModule,

    // Custom
    ComponentsModule
  ]
})
export class ChartsModule {}
